import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { ArticleItem } from '../../../stores/ArticleStore';
import { Price } from '../../Price';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { CenteredImage } from '../../CenteredImage';
import { LongButton } from '../../LongButton';
import { CenteredText } from '../../CenteredText';

interface ArticleInformationsProps {
    articleItem: ArticleItem;
    selectedBasketIdsCount: number;
    showPrices: boolean;
}

export class ArticleInformations extends BaseComponent<ArticleInformationsProps, {}> {
    public render(): JSX.Element | null {
        if ((this.props.articleItem == null && this.props.selectedBasketIdsCount < 2) || this.props.selectedBasketIdsCount === 0) {
            return null;
        }
        let image: JSX.Element | null = null;
        if (this.props.articleItem != null && !egr.wcf.utils.string.isNullOrEmpty(this.props.articleItem.image)) {
            if (AppConfigurationStore.getState().inApp) {
                image = <CenteredImage src={this.props.articleItem.image} className="button-image"/>;
            } else {
                image = <CenteredImage src={this.props.articleItem.image} className="property-article-image"/>;
            }
        }

        if (
            this.props.articleItem != null &&
            this.props.articleItem.properties != null &&
            this.props.articleItem.properties.article != null &&
            this.props.selectedBasketIdsCount === 1
        ) {
            if (AppConfigurationStore.getState().inApp) {
                return (
                    <LongButton className={'middle-size article-info' + (image != null ? ' right-image' : '')}>
                        {image}
                        <CenteredText maxHeight="100%" className="" verticalAlign="top">
                            <div className="long-button-text">{this.props.articleItem.properties.article.shortText}</div>
                            {this.articlePrice(this.props.articleItem.properties.article)}
                        </CenteredText>
                    </LongButton>
                );
            }
            return (
                <div className={'property-article' + (image != null ? ' article-info-image' : '')}>
                    {image}
                    <div
                        className={'property-article-name' + (this.props.showPrices ? '' : ' multiline')}
                    >
                        {this.props.articleItem.properties.article.shortText}
                    </div>
                    {this.articlePrice(this.props.articleItem.properties.article)}
                </div>
            );
        }
        if (AppConfigurationStore.getState().inApp) {
            return (
                <LongButton className="middle-size right-image article-info">
                    <CenteredImage src={null} className="button-image multiselect-image"/>
                    <CenteredText maxHeight="100%" className="" verticalAlign="top">
                        <div className="long-button-text">({t('Multiple articles selected.')})</div>
                    </CenteredText>
                </LongButton>
            );
        }
        return (
            <div className="property-article multiple-articles">
                <div className={'property-article-name'}>({t('Multiple articles selected.')})</div>
            </div>
        );
    }

    protected articlePrice = (articleProperties: egr.wcf.eaiws.basket.ArticleProperties): JSX.Element | null => {
        if (this.props.showPrices && articleProperties != null) {
            return (
                <div className="long-button-text">
                    <Price value={articleProperties.salesPrice} currency={articleProperties.currency} />
                </div>
            );
        }
        return null;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/ArticleInformations.tsx